import { Button, Text, Label, PrimaryButton, Stack, MessageBar, MessageBarType, Checkbox, Toggle } from '@fluentui/react';
import * as React from 'react';
import { IAttendee } from '../../../Models/Attendees/IAttendee';
import { EventPriceTypeEnum } from '../../../Models/Event/EventPriceTypeEnum';
import { IEvent } from '../../../Models/Event/IEvent';
import { IProfileContact } from '../../../Models/Profile/IProfileContact';
import { maxAgeOdchod } from '../../../App/Consts'
import { getAge } from '../../../Tools/DateTime';
import { EventTypeEnum } from '../../../Models/Event/EventTypeEnum';
interface INewOrderRecapProps {
    profileInfo: IProfileContact;   
    email: string;
    event: IEvent;
    isAuth: boolean;
    selectedAttendees: IAttendee[];
    goToStep: (step: number) => void;
    finishOrder: () => void;
    goBack: () => void;
    isLoading: boolean;
}


export const NewOrderRecap: React.FunctionComponent<INewOrderRecapProps> = (props) => {

    const newRegistration = () => {
        return (<Stack styles={{ root: { paddingTop: 5, paddingBottom:5 } }}>
            <Label>Po odeslání objednávky bude vytvořena registrace pro: </Label>
            <Text>Přihlašovací jméno : {props.email}</Text>
            <Text>{props.profileInfo.firstName + " " + props.profileInfo.lastName}</Text>
            <Text>{props.profileInfo.billingStreet}</Text>
            <Text>{props.profileInfo.billingPostalCode + " " + props.profileInfo.city}</Text>
            <MessageBar messageBarType={MessageBarType.info}>
                Pokyny pro dokončení registrace a nastavení přihlašovacího hesla vám budou odeslány na zadanou emailovou adresu <b>{props.email}</b>
            </MessageBar>
        </Stack>)
    }

    const invoiceContact = () => {
        return (<Stack styles={{ root: { paddingTop: 5, paddingBottom: 5 } }}>
            <Label>Fakturační údaje</Label>
            {props.profileInfo.company != "" ?
                <Text>{props.profileInfo.company}</Text>
                : null}
            {props.profileInfo.ic != "" ?
                <Text>{props.profileInfo.ic}</Text>
                : null}
            {props.profileInfo.dic != "" ?
                <Text>{props.profileInfo.dic}</Text>
                : null}
            <Text>{props.profileInfo.firstName + " " + props.profileInfo.lastName}</Text>
            <Text>{props.profileInfo.billingStreet}</Text>
            <Text>{props.profileInfo.billingPostalCode + " " + props.profileInfo.city}</Text>
        </Stack>)
    }

    const order = () => {
        return (
            <Stack styles={{ root: { paddingTop: 5, paddingBottom: 5 } }}>
            <Label>Objednaná akce</Label>
                <Text>{props.event.name}</Text>
                <Label>{(props.event.eventTypeEnum === EventTypeEnum.Training ? "Hodinová dotace kurzu:" : "Počet lekcí:")} {props.event?.numberOfLessons + (props.event.priceType === EventPriceTypeEnum.BySemester ? " (pololetí)" : " vyuč. hodin")} </Label>
                <Text>{(props.event.eventTypeEnum === EventTypeEnum.Training ? "Datum a čas:" : "První lekce:")} {(props.event.dateOfFirstLesson as Date).toLocaleDateString("cs-CZ")} {props.event.time} </Text>
                {props.event.priceType === EventPriceTypeEnum.ByEvent ?
                    <Text>Cena za akci {props.event.price},- Kč/osobu</Text> : null}
                {props.event.priceType === EventPriceTypeEnum.BySemester ?
                    <Stack>
                        <Text>Cena za 1 pololetí {props.event.firstSemesterPrice},- Kč/osobu</Text> 
                        <Text>Cena za 2 pololetí {props.event.secondSemesterPrice},- Kč/osobu</Text> 
                    </Stack>
                    : null}
        </Stack>)
    }

    const attendees = () => {
        return (<Stack styles={{ root: { paddingTop: 5, paddingBottom: 5 } }}>
            <Label>Účastníci akce</Label>
            {props.selectedAttendees.map(item => {
                return <Stack horizontal tokens={{ childrenGap: 10 }}>
                    <Text>{(item.degree ? `${item.degree} ` : "") + item.firstName + " " + item.lastName}</Text>
                    {getAge(item.dateOfBirth) < maxAgeOdchod ? <Text>po skončení odchází {item.doprovod}</Text>:null}
                    </Stack>
            })}

        </Stack>)
    }

    const totalPrice = () => {
        return (<Stack styles={{ root: { paddingTop: 5, paddingBottom: 5 } }}>
            {props.event.priceType === EventPriceTypeEnum.ByEvent ?
                <Label>Cena celkem za akci: {props.event.price * props.selectedAttendees.length},- Kč</Label>
                : null}
            {props.event.priceType === EventPriceTypeEnum.BySemester ?
                <Stack>
                <Label>Cena celkem:</Label>
                    <Label> První pololetí: {props.event.firstSemesterPrice * props.selectedAttendees.length},- Kč</Label>
                    <Label> První pololetí: {props.event.secondSemesterPrice * props.selectedAttendees.length},- Kč</Label>
                </Stack>
                : null}

        </Stack>)
    }

    return (<Stack horizontalAlign="center" tokens={{ childrenGap: 15 }}>
        <Stack horizontalAlign="start" styles={{ root: { maxWidth:400 } }}>
        <h2>Suma sumárum</h2>
        {!props.isAuth?
            newRegistration() 
            : null}

        {order()}

        {attendees() }

        {invoiceContact()}

        {totalPrice()}
            
        </Stack>


        <Stack horizontal wrap tokens={{ childrenGap: 10 }} styles={{ root: { paddingTop: 20 } }}>
            <Button text="< Zpět" onClick={props.goBack} />
            <PrimaryButton text="Dokončit objednávku" disabled={props.isLoading} styles={{ root: { width: 200 } }} onClick={props.finishOrder} />
        </Stack>

    </Stack>)
}
